import type { NextPage } from 'next';
import Image from 'next/image';
import Link from 'next/link';
import _ from 'lodash';
import { getPlatforms, Platform } from '../../models/Platform';

type Props = {
	categories: Platform[];
};

const Brands: NextPage<Props> = ({ categories }) => {
	const createCategoryCard = (platform: Platform) => {
		return (
			<Link
				href={'#'}
				key={`platform-card-${platform.code}`}
				className="flex shadow-lg rounded-2xl w-64 m-4 p-4 py-6 bg-white">
				<div className="flex flex-wrap	grow items-center justify-center ">
					<h2 className="text-gray-800 text-xl font-medium mb-4 mt-4">{platform.name}</h2>
				</div>
			</Link>
		);
	};

	return (
		<div className="container">
			<div>
				<h1 className="text-3xl dark:text-gray-200">Todas las categorías de juegos.</h1>
				<h2 className="text-xl	dark:text-gray-200">
					A continuación te mostramos todas las categorías para jugar hasta el infinito.
				</h2>
			</div>
			<div className="flex flex-wrap justify-center">
				{categories.map((platform: Platform) => {
					return createCategoryCard(platform);
				})}
			</div>
		</div>
	);
};

export async function getStaticProps() {
	const { PrismaClient } = await import('@prisma/client');
	const prisma = new PrismaClient();

	const categories = await prisma.categories.findMany({ orderBy: [{ name: 'asc' }] });

	return {
		props: {
			categories: JSON.parse(JSON.stringify(categories)),
			title: 'Categorias'
		}
	};
}

export default Brands;
